var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import analytics from '@viewlift/analytics/analytics-core/index.cjs';
import googleAnalytics from '@viewlift/analytics/google-analytics/index.cjs';
import userBeacon from '@viewlift/analytics/user-beacon/index.cjs';
export default function trackEvent(eventName, payload, trackingID) {
    var _a, _b, _c;
    if (typeof window !== 'undefined') {
        if (window === null || window === void 0 ? void 0 : window.dataLayer) {
            window.dataLayer.push(__assign({ 'event': eventName }, payload));
        }
        var trackingId = trackingID || ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.googleAnalyticsId);
        if (!trackingId)
            return;
        analytics({
            app: 'analytics',
            eventName: eventName,
            plugins: [
                googleAnalytics({
                    trackingId: trackingId,
                    initialize: function () {
                    },
                    payload: payload
                }),
            ]
        });
    }
}
export function trackUserEvent(payload) {
    var _a, _b, _c;
    if (typeof window !== 'undefined') {
        return analytics({
            app: 'user-analytics',
            apiBaseUrl: (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.userBeaconUrl,
            plugins: [
                userBeacon({
                    initialize: function () {
                    },
                    payload: payload,
                }),
            ]
        });
    }
}
